import * as React from 'react'

const ErrorMessage = (props) => {
  return (
    <div className='error-message'>
      <i className='fa fa-exclamation-triangle' color='red'></i>
      <span className='error-message-text'>{props.text}</span>
    </div>
  )
}

export default ErrorMessage
